/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
    registrationLabel: {
        id: 'qnb.spm.registrationLookup.registrationLabel',
        defaultMessage: 'What is the registration number of your {vehicle}?'
    },
    enterReg: {
        id: 'qnb.spm.registrationLookup.enterReg',
        defaultMessage: 'ENTER REG'
    },
    findVehicleButton: {
        id: 'qnb.spm.registrationLookup.findVehicle',
        defaultMessage: 'Find {vehicle}'
    },
    enterManualDetails: {
        id: 'qnb.spm.registrationLookup.dontKnowReg',
        defaultMessage: 'Don\'t know your registration number?'
    },
    regNotFoundError: {
        id: 'qnb.spm.registrationLookup.regNotFound',
        defaultMessage: 'We\'ve been unable to find your vehicle. You can try again, or enter your details manually by clicking \'Don\'t know your registration number?\' below'
    },
    regNotFoundErrorLookupOnly: {
        id: 'qnb.spm.registrationLookup.regNotFoundErrorLookupOnly',
        defaultMessage: 'We’ve been unable to find your vehicle, please try again'
    },
    lookupIncomplete: {
        id: 'qnb.spm.registrationLookup.lookupIncomplete',
        defaultMessage: 'Please click the \'Find {vehicle}\' button to continue'
    },
});
